import { accountSlice } from './account.slice.ts';

export const { SET_ACCOUNT, SET_ACTIVE_PATH, SET_RECEPTION_CENTER } = accountSlice.actions;
